import { TitleBlockInfo } from './TitleBlockInfo';
import { TitleBlockCanvas } from './Index';

declare let THREE: any;

export class TitleBlock extends (THREE.Mesh as { new(geometry, material): any }) {
  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));
  static readonly Name = 'TitleBlock';
  public imageWidth;
  public imageHeight;
  canvasWidth: number;
  canvasHeight: number;
  image: any;
  Scale: number;

  info: any;
  TopBlock: TitleBlockCanvas;
  LeftBlock: TitleBlockCanvas;
  RightBlock: TitleBlockCanvas;
  LegendBlock: TitleBlockCanvas;
  BottomBlock: TitleBlockCanvas;

  constructor(image, info) {
    const geometry = new THREE.PlaneBufferGeometry(1, 1).applyMatrix(TitleBlock.rotationTransform);
    const material = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, transparent: true });
    super(geometry, material);
    this.image = image;
    this.info = info;

    this.TopBlock = new TitleBlockCanvas();
    this.LeftBlock = new TitleBlockCanvas();
    this.RightBlock = new TitleBlockCanvas();
    this.LegendBlock = new TitleBlockCanvas();
    this.BottomBlock = new TitleBlockCanvas();

    this.name = TitleBlock.Name;
  }

  private _addUnderline(ctx, startX, startY, endX, endY) {
    ctx.beginPath();
    ctx.moveTo(startX, startY);
    ctx.lineTo(endX, endY);
    ctx.stroke();
  }

  update(scale, paperWidth, paperHeight, paperPos) {
    var canvas = document.createElement('canvas');
    this.Scale = (scale.scale * paperWidth) / 1.295 / 21.59;

    const width = (paperHeight * scale.scale) / 1.295;
    const height = (paperWidth * scale.scale) / 1.295;
    this.canvasWidth = width;
    this.canvasHeight = height;

    const verticalShift = height * 0.08;//paperWidth == 21.59 ? height * 0.08 : 0;

    var paperPos = paperPos.clone();
    paperPos.z -= verticalShift;

    const newPos = new THREE.Vector3(
      paperPos.x + (width * (0.16 - 0.135)) / 2,
      this.position.y,
      paperPos.z - height * 0.04
    );

    this.position.set(newPos.x, this.position.y, newPos.z + height * 0.05);
    this.scale.set(width, 1, height * 1.1);

    canvas.width = (this.canvasWidth * 100) / this.Scale;
    canvas.height = (this.canvasHeight * 100) / this.Scale;
    var ctx = canvas.getContext('2d');
    ctx.lineWidth = 4;
    ctx.strokeRect(0, 0, canvas.width, canvas.height);
    const ImHeigth = (canvas.width * 0.9 * this.image.height) / this.image.width;
    // ctx.drawImage(this.image, canvas.width * 0.05, canvas.width * 0.05, canvas.width * 0.9, ImHeigth);

    let text = 'SCALE ' + scale.text;
    let fontSize = 35;
    let font = 'LatoWebLight';
    // font = "bold " + fontSize + "px " + font;
    ctx.font = 'bold ' + fontSize + 'px ' + font;
    ctx.textAlign = 'right';
    ctx.fillText(text, canvas.width - 10, canvas.height - fontSize / 2);

    if (!this.material.map) {
      this.material.map = new THREE.Texture(canvas);
    }
    this.material.map.image = canvas;

    this.material.map.needsUpdate = true;
    this.material.needsUpdate = true;

    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    this.canvasWidth = width;
    this.canvasHeight = height / 30;
    canvas = document.createElement('canvas');
    this.TopBlock.position.set(
      newPos.x,
      this.position.y,
      newPos.z - height / 2 - this.canvasHeight / 2
    );
    this.TopBlock.scale.set(this.canvasWidth, 1, this.canvasHeight);

    canvas.width = (this.canvasWidth * 100) / this.Scale;
    canvas.height = (this.canvasHeight * 100) / this.Scale;

    ctx = canvas.getContext('2d');
    ctx.lineWidth = 4;

    console.log('this.info', this.info);

    text = this.info.TopItems[0].name;
    fontSize = 35;
    font = 'LatoWebLight';
    // font = "bold " + fontSize + "px " + font;
    ctx.font = 'bold ' + fontSize + 'px ' + font;
    ctx.textAlign = 'center';
    let textSize = ctx.measureText(text);

    ctx.fillText(text, textSize.width / 2 + 1, canvas.height - fontSize / 2 - 1);
    text = this.getDate(); //info.TopItems[0].value;
    let textPos = canvas.width * 0.12 - (canvas.width * 0.12 - (textSize.width + 1)) / 2;
    ctx.fillText(
      text,
      textPos,
      canvas.height - fontSize / 2 - 1,
      canvas.width * 0.22 - textSize.width
    );

    text = this.info.TopItems[1].name;
    textSize = ctx.measureText(text);
    textPos = canvas.width * 0.12 + textSize.width / 2;
    ctx.fillText(text, textPos, canvas.height - fontSize / 2 - 1);
    textPos = canvas.width * 0.34 - (canvas.width * 0.22 - (textSize.width + 1)) / 2;
    text = this.info.TopItems[1].value;
    ctx.fillText(
      text,
      textPos,
      canvas.height - fontSize / 2 - 1,
      canvas.width * 0.22 - textSize.width
    );

    text = this.info.TopItems[2].name;
    textSize = ctx.measureText(text);
    textPos = canvas.width * 0.34 + textSize.width / 2;
    ctx.fillText(text, textPos, canvas.height - fontSize / 2 - 1);
    textPos = canvas.width * 0.56 - (canvas.width * 0.22 - (textSize.width + 1)) / 2;
    text = this.info.TopItems[2].value;
    ctx.fillText(
      text,
      textPos,
      canvas.height - fontSize / 2 - 1,
      canvas.width * 0.22 - textSize.width
    );

    text = this.info.TopItems[3].name;
    textSize = ctx.measureText(text);
    textPos = canvas.width * 0.56 + textSize.width / 2;
    ctx.fillText(text, textPos, canvas.height - fontSize / 2 - 1, canvas.width * 0.22 - textSize.width);
    textPos = canvas.width * 0.87 - (canvas.width * 0.31 - (textSize.width + 1)) / 2;
    text = this.info.TopItems[3].value;
    ctx.fillText(text, textPos, canvas.height - fontSize / 2 - 1);

    text = this.info.TopItems[4].name;
    textSize = ctx.measureText(text);
    textPos = canvas.width * 0.87 + textSize.width / 2;
    ctx.fillText(text, textPos, canvas.height - fontSize / 2 - 1);
    textPos = canvas.width - (canvas.width * 0.13 - (textSize.width + 1)) / 2;
    text = this.info.TopItems[4].value;
    ctx.fillText(text, textPos, canvas.height - fontSize / 2 - 1);

    ctx.lineWidth = 10;
    // ctx.strokeRect(0, 0, canvas.width, canvas.height);

    if (!this.TopBlock.material.map) {
      this.TopBlock.material.map = new THREE.Texture(canvas);
    }
    this.TopBlock.material.map.image = canvas;

    this.TopBlock.material.map.needsUpdate = true;
    this.TopBlock.material.needsUpdate = true;
    this.add(this.TopBlock);

    //////////////////////////////////////////////////////////////////////////////////////////////

    this.canvasWidth = width * 0.16;
    this.canvasHeight = height;
    canvas = document.createElement('canvas');
    this.LeftBlock.position.set(
      newPos.x - width / 2 - this.canvasWidth / 2,
      this.position.y,
      newPos.z
    );
    this.LeftBlock.scale.set(this.canvasWidth, 1, this.canvasHeight);

    canvas.width = (this.canvasWidth * 100) / this.Scale;
    canvas.height = (this.canvasHeight * 100) / this.Scale;

    ctx = canvas.getContext('2d');
    ctx.lineWidth = 4;
    fontSize = 35;
    let currentPos = fontSize;
    // fontSize *= 10;

    ctx.font = 'bold ' + fontSize + 'px ' + font;

    this.info.LeftSideItems.forEach(item => {
      if (item.name !== "DECK HEIGHT") {
        ctx.textAlign = 'left';
        text = item.name;
        ctx.fillText(text, 15, currentPos);
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width + 5,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        ctx.textAlign = 'right';
        // ctx.font = "bold " + fontSize + "px " + font;
        text = item.value;
        ctx.fillText(text, canvas.width - 15, currentPos);
        currentPos += fontSize * 1.3;
      }
    });

    currentPos += fontSize * 0.6;

    for (let i = 0; i < this.info.PostItems.length - 1; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.PostItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.PostItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
        currentPos += fontSize * 1.3;
      } else {
        ctx.textAlign = 'left';
        text = this.info.PostItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.PostItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.PostItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }

    ctx.textAlign = 'left';
    text = this.info.PostItems[this.info.PostItems.length - 1].name;
    ctx.fillText(text, 15, currentPos);
    ctx.textAlign = 'right';
    this._addUnderline(
      ctx,
      15 + ctx.measureText(text).width,
      currentPos + 5,
      canvas.width - 15,
      currentPos + 5
    );
    // ctx.font = "bold " + fontSize + "px " + font;
    text = this.info.PostItems[this.info.PostItems.length - 1].value;
    ctx.fillText(text, canvas.width - 15, currentPos);
    currentPos += fontSize * 1.9;

    this.info.PanelItems.forEach(item => {
      ctx.textAlign = 'left';
      text = item.name;
      ctx.fillText(text, 15, currentPos);
      ctx.textAlign = 'right';
      this._addUnderline(
        ctx,
        15 + ctx.measureText(text).width,
        currentPos + 5,
        canvas.width - 15,
        currentPos + 5
      );
      // ctx.font = "bold " + fontSize + "px " + font;
      text = item.value;
      ctx.fillText(text, canvas.width - 15, currentPos);
      currentPos += fontSize * 1.3;
    });

    currentPos += fontSize * 0.6;

    ctx.textAlign = 'left';
    text = 'TOP RAIL';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.TopRailItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.TopRailItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.TopRailItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
        currentPos += fontSize * 1.3;
      } else {
        ctx.textAlign = 'left';
        text = this.info.TopRailItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.TopRailItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.TopRailItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }

    ctx.textAlign = 'left';
    text = 'SERIES 150 TOP';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.Series150TopItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.Series150TopItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.Series150TopItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
        currentPos += fontSize * 1.3;
      } else {
        ctx.textAlign = 'left';
        text = this.info.Series150TopItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.Series150TopItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.Series150TopItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }

    ctx.textAlign = 'left';
    text = 'BOTTOM RAIL';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.BottomRailItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.BottomRailItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.BottomRailItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
        currentPos += fontSize * 1.3;
      } else {
        ctx.textAlign = 'left';
        text = this.info.BottomRailItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.BottomRailItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.BottomRailItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }

    currentPos += fontSize * 0.6;

    ctx.textAlign = 'left';
    text = 'SNAP CAP INSERT';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.SCIItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.SCIItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.SCIItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.SCIItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.SCIItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.SCIItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.3;

    ctx.textAlign = 'left';
    text = 'TOP INSERT';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.TopInsertItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.TopInsertItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.TopInsertItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.TopInsertItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.TopInsertItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.TopInsertItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.3;
    ctx.textAlign = 'left';
    text = 'BOTTOM INSERT';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.BottomInsertItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.BottomInsertItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.BottomInsertItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.BottomInsertItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.BottomInsertItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.BottomInsertItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.3;
    ctx.textAlign = 'left';
    text = 'VINYLTOP & BOT';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.VTBItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.VTBItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.VTBItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.VTBItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.VTBItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.VTBItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.3;

    ctx.lineWidth = 10;
    // ctx.strokeRect(0, 0, canvas.width, canvas.height);

    if (!this.LeftBlock.material.map) {
      this.LeftBlock.material.map = new THREE.Texture(canvas);
    }
    this.LeftBlock.material.map.image = canvas;

    this.LeftBlock.material.map.needsUpdate = true;
    this.LeftBlock.material.needsUpdate = true;
    this.add(this.LeftBlock);

    ///////////////////////////////////////////////////////////////////////////////////

    this.canvasWidth = width * 0.135;
    this.canvasHeight = height * 1.15;
    canvas = document.createElement('canvas');
    this.RightBlock.position.set(
      newPos.x + width / 2 + this.canvasWidth / 2,
      this.position.y,
      newPos.z + height * 0.075
    );
    this.RightBlock.scale.set(this.canvasWidth, 1, this.canvasHeight);

    canvas.width = (this.canvasWidth * 100) / this.Scale;
    canvas.height = (this.canvasHeight * 100) / this.Scale;

    ctx = canvas.getContext('2d');
    ctx.lineWidth = 4;

    currentPos = fontSize;

    ctx.font = 'bold ' + fontSize + 'px ' + font;

    this.info.SpliceItems.forEach(item => {
      ctx.textAlign = 'left';
      text = item.name;
      ctx.fillText(text, 15, currentPos);
      ctx.textAlign = 'right';
      this._addUnderline(
        ctx,
        15 + ctx.measureText(text).width,
        currentPos + 5,
        canvas.width - 15,
        currentPos + 5
      );
      // ctx.font = "bold " + fontSize + "px " + font;
      text = item.value;
      ctx.fillText(text, canvas.width - 15, currentPos);
      currentPos += fontSize * 1.3;
    });

    ctx.textAlign = 'left';
    text = 'SQUARE POST CAP';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.SquarePostCapItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.SquarePostCapItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.SquarePostCapItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.SquarePostCapItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.SquarePostCapItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.SquarePostCapItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.3;

    ctx.textAlign = 'left';
    text = '45° POST CAP';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.Post45CapItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.Post45CapItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.Post45CapItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.Post45CapItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.Post45CapItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.Post45CapItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.3;

    this.info.PicketPlugItems.forEach(item => {
      ctx.textAlign = 'left';
      text = item.name;
      ctx.fillText(text, 15, currentPos);
      ctx.textAlign = 'right';
      this._addUnderline(
        ctx,
        15 + ctx.measureText(text).width,
        currentPos + 5,
        canvas.width - 15,
        currentPos + 5
      );
      // ctx.font = "bold " + fontSize + "px " + font;
      text = item.value;
      ctx.fillText(text, canvas.width - 15, currentPos);
      currentPos += fontSize * 1.3;
    });

    ctx.textAlign = 'left';
    text = 'BASE PLATE CVR';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.BPItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.BPItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.BPItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.BPItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.BPItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.BPItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.9;

    this.info.PKItems.forEach(item => {
      ctx.textAlign = 'left';
      text = item.name;
      ctx.fillText(text, 15, currentPos);
      ctx.textAlign = 'right';
      this._addUnderline(
        ctx,
        15 + ctx.measureText(text).width,
        currentPos + 5,
        canvas.width - 15,
        currentPos + 5
      );
      // ctx.font = "bold " + fontSize + "px " + font;
      text = item.value;
      ctx.fillText(text, canvas.width - 15, currentPos);
      currentPos += fontSize * 1.3;
    });

    currentPos += fontSize * 0.6;

    ctx.textAlign = 'left';
    text = 'TOUCH-UP PAINT';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.TouchUpItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.TouchUpItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.TouchUpItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.TouchUpItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.TouchUpItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.TouchUpItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.3;

    ctx.textAlign = 'left';
    text = 'LIGHTING';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.LightingItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.LightingItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.LightingItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.LightingItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.LightingItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.LightingItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.9;

    this.info.GatesItems.forEach(item => {
      ctx.textAlign = 'left';
      text = item.name;
      ctx.fillText(text, 15, currentPos);
      ctx.textAlign = 'right';
      this._addUnderline(
        ctx,
        15 + ctx.measureText(text).width,
        currentPos + 5,
        canvas.width - 15,
        currentPos + 5
      );
      // ctx.font = "bold " + fontSize + "px " + font;
      text = item.value;
      ctx.fillText(text, canvas.width - 15, currentPos);
      currentPos += fontSize * 1.3;
    });

    currentPos += fontSize * 0.6;

    ctx.textAlign = 'left';
    text = 'HANDRAIL';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.HandrailItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.HandrailItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.HandrailItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.HandrailItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.HandrailItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.HandrailItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.3;

    this.info.HRBrktItems.forEach(item => {
      ctx.textAlign = 'left';
      text = item.name;
      ctx.fillText(text, 15, currentPos);
      ctx.textAlign = 'right';
      this._addUnderline(
        ctx,
        15 + ctx.measureText(text).width,
        currentPos + 5,
        canvas.width - 15,
        currentPos + 5
      );
      // ctx.font = "bold " + fontSize + "px " + font;
      text = item.value;
      ctx.fillText(text, canvas.width - 15, currentPos);
      currentPos += fontSize * 1.3;
    });

    ctx.textAlign = 'left';
    text = 'HR RETURN';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.HRReturnItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.HRReturnItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.HRReturnItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
        currentPos += fontSize * 1.3;
      } else {
        ctx.textAlign = 'left';
        text = this.info.HRReturnItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.HRReturnItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.HRReturnItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }

    this.info.HRBendItems.forEach(item => {
      ctx.textAlign = 'left';
      text = item.name;
      ctx.fillText(text, 15, currentPos);
      ctx.textAlign = 'right';
      this._addUnderline(
        ctx,
        15 + ctx.measureText(text).width,
        currentPos + 5,
        canvas.width - 15,
        currentPos + 5
      );
      // ctx.font = "bold " + fontSize + "px " + font;
      text = item.value;
      ctx.fillText(text, canvas.width - 15, currentPos);
      currentPos += fontSize * 1.3;
    });

    ctx.textAlign = 'left';
    text = 'HR SPLICE';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.HRSpliceItems.length; i++) {
      if (i % 2) {
        ctx.textAlign = 'left';
        text = this.info.HRSpliceItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.HRSpliceItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.HRSpliceItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          this.info.HRSpliceItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.HRSpliceItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      }
    }
    currentPos += fontSize * 1.9;

    ctx.textAlign = 'left';
    text = 'CABLERAIL KIT';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    this.info.CablerailKitItems.forEach(item => {
      ctx.textAlign = 'left';
      text = item.name;
      ctx.fillText(text, 15, currentPos);
      ctx.textAlign = 'right';
      this._addUnderline(
        ctx,
        15 + ctx.measureText(text).width,
        currentPos + 5,
        this.info.HRSpliceItems.length === 1 ? canvas.width - 15 : canvas.width / 2 - 15,
        currentPos + 5
      );
      // ctx.font = "bold " + fontSize + "px " + font;
      text = item.value;
      ctx.fillText(text, canvas.width - 15, currentPos);
      currentPos += fontSize * 1.3;
    });

    for (let i = 0; i < 5; i++) {
      ctx.textAlign = 'right';
      text = this.info.CablerailItems[i * 2].value;
      ctx.fillText(text, canvas.width / 2 - 15, currentPos);

      ctx.textAlign = 'center';
      text = '@';
      ctx.fillText(text, canvas.width / 2, currentPos);
      this._addUnderline(
        ctx,
        15,
        currentPos + 5,
        canvas.width / 2 - ctx.measureText(text).width / 2 - 15,
        currentPos + 5
      );
      this._addUnderline(
        ctx,
        canvas.width / 2 + ctx.measureText(text).width / 2 + 15,
        currentPos + 5,
        canvas.width - 15,
        currentPos + 5
      );

      ctx.textAlign = 'left';
      text = this.info.CablerailItems[i * 2 + 1].value;
      ctx.fillText(text, canvas.width / 2 + 15, currentPos);

      currentPos += fontSize * 1.3;
    }

    ctx.textAlign = 'left';
    text = 'CUSTOM CABLE';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < 2; i++) {
      ctx.textAlign = 'right';
      text = this.info.CustomCableItems[i * 2].value;
      ctx.fillText(text, canvas.width / 2 - 15, currentPos);

      ctx.textAlign = 'center';
      text = '@';
      ctx.fillText(text, canvas.width / 2, currentPos);
      this._addUnderline(
        ctx,
        15,
        currentPos + 5,
        canvas.width / 2 - ctx.measureText(text).width / 2 - 15,
        currentPos + 5
      );
      this._addUnderline(
        ctx,
        canvas.width / 2 + ctx.measureText(text).width / 2 + 15,
        currentPos + 5,
        canvas.width - 15,
        currentPos + 5
      );

      ctx.textAlign = 'left';
      text = this.info.CustomCableItems[i * 2 + 1].value;
      ctx.fillText(text, canvas.width / 2 + 15, currentPos);

      currentPos += fontSize * 1.3;
    }

    ctx.textAlign = 'left';
    text = 'BEVELED WASHER';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.BeveledWasherItems.length; i++) {
      if (i % 2 && i < 2) {
        ctx.textAlign = 'left';
        text = this.info.BeveledWasherItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.BeveledWasherItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
        currentPos += fontSize * 1.3;
      } else if (i < 2) {
        ctx.textAlign = 'left';
        text = this.info.BeveledWasherItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.BeveledWasherItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.BeveledWasherItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.BeveledWasherItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
        currentPos += fontSize * 1.3;
      }
    }

    currentPos += fontSize * 0.6;

    ctx.textAlign = 'left';
    text = 'PACKAGING';
    ctx.fillText(text, 15, currentPos);
    currentPos += fontSize * 1.3;

    for (let i = 0; i < this.info.PackagingItems.length; i++) {
      if (i % 2 && i < 2) {
        ctx.textAlign = 'left';
        text = this.info.PackagingItems[i].name;
        ctx.fillText(text, canvas.width / 2 + 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          canvas.width / 2 + 15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.PackagingItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
        currentPos += fontSize * 1.3;
      } else if (i < 2) {
        ctx.textAlign = 'left';
        text = this.info.PackagingItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width / 2 - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.PackagingItems[i].value;
        ctx.fillText(text, canvas.width / 2 - 15, currentPos);
      } else {
        ctx.textAlign = 'left';
        text = this.info.PackagingItems[i].name;
        ctx.fillText(text, 15, currentPos);
        ctx.textAlign = 'right';
        this._addUnderline(
          ctx,
          15 + ctx.measureText(text).width,
          currentPos + 5,
          canvas.width - 15,
          currentPos + 5
        );
        // ctx.font = "bold " + fontSize + "px " + font;
        text = this.info.PackagingItems[i].value;
        ctx.fillText(text, canvas.width - 15, currentPos);
        currentPos += fontSize * 1.3;
      }
    }

    currentPos += fontSize * 0.6;

    ctx.lineWidth = 10;
    // ctx.strokeRect(0, 0, canvas.width, canvas.height);

    if (!this.RightBlock.material.map) {
      this.RightBlock.material.map = new THREE.Texture(canvas);
    }
    this.RightBlock.material.map.image = canvas;

    this.RightBlock.material.map.needsUpdate = true;
    this.RightBlock.material.needsUpdate = true;
    this.add(this.RightBlock);

    ///////////////////////////////////////////////////////////////////////////////////

    this.canvasWidth = width;
    this.canvasHeight = height / 20;
    canvas = document.createElement('canvas');
    this.LegendBlock.position.set(
      newPos.x,
      this.position.y,
      newPos.z + height / 2 + this.canvasHeight / 2 + height * 0.1
    );
    this.LegendBlock.scale.set(this.canvasWidth, 1, this.canvasHeight);

    canvas.width = (this.canvasWidth * 100) / this.Scale;
    canvas.height = (this.canvasHeight * 100) / this.Scale;

    ctx = canvas.getContext('2d');
    ctx.lineWidth = 4;

    text = 'LEGEND';
    fontSize = 45;
    font = 'LatoWebLight';
    // font = "bold " + fontSize + "px " + font;
    ctx.font = 'bold ' + fontSize + 'px ' + font;
    let textLength = ctx.measureText(text).width;
    ctx.textAlign = 'left';
    ctx.fillText(text, 15, 45);

    fontSize = 29;
    ctx.font = 'bold ' + fontSize + 'px ' + font;
    text =
      'IN - INTERMEDIATE   TT - THREADED TERM   QC - QUICK CONNECT   SC - SINGLE CORNER   PK - PICKET   C - CORNER 45 - 45°   B - BLANK   45B - BLANK 45°   PKB - BLANK PICKET';

    ctx.fillText(text, 30 + textLength, 45);

    text =
      'INS - INT STAIR   TTS - TT STAIR   QCT - QC TERMINATION   QCS - QC STAIR   PKS - PK STAIR  CE - CONCEAL END   CST - CONCEAL STAIR TOP   CSB - CONCEAL STAIR BOTTOM   NSP - NON-STD   E - END';

    ctx.fillText(text, 10, 90);

    ctx.lineWidth = 7;
    ctx.strokeRect(0, 0, canvas.width, canvas.height);

    if (!this.LegendBlock.material.map) {
      this.LegendBlock.material.map = new THREE.Texture(canvas);
    }
    this.LegendBlock.material.map.image = canvas;

    this.LegendBlock.material.map.needsUpdate = true;
    this.LegendBlock.material.needsUpdate = true;
    this.add(this.LegendBlock);

    //////////////////////////////////////////////////////////////////////////////////////

    this.canvasWidth = width * 1.16;
    this.canvasHeight = height * 0.1;
    canvas = document.createElement('canvas');
    this.BottomBlock.position.set(
      newPos.x - this.canvasWidth / 2 + width / 2,
      this.position.y,
      newPos.z + height / 2 + this.canvasHeight / 2 + height / 20 + height * 0.1
    );
    this.BottomBlock.scale.set(this.canvasWidth, 1, this.canvasHeight);

    canvas.width = (this.canvasWidth * 100) / this.Scale;
    canvas.height = (this.canvasHeight * 100) / this.Scale;

    ctx = canvas.getContext('2d');
    ctx.lineWidth = 4;

    const ImWidth = (canvas.height * 0.9 * this.image.width) / this.image.height;
    ctx.drawImage(
      this.image,
      canvas.height * 0.05,
      canvas.height * 0.05,
      ImWidth,
      canvas.height * 0.9
    );

    text = '2603 Union St';
    fontSize = 23;
    font = 'LatoWebLight';
    // font = "bold " + fontSize + "px " + font;
    ctx.font = 'bold ' + fontSize + 'px ' + font;
    textLength = ctx.measureText(text).width;
    ctx.textAlign = 'left';
    ctx.fillText(text, ImWidth + 10 + canvas.height * 0.05, canvas.height * 0.2 - 3);
    text = 'Oakland, CA 94607';
    const tw = ctx.measureText(text).width;
    ctx.fillText(text, ImWidth + 10 + canvas.height * 0.05, canvas.height * 0.4 - 3);
    text = 'P: 800-888-2418';
    ctx.fillText(text, ImWidth + 10 + canvas.height * 0.05, canvas.height * 0.6 - 3);
    text = 'F: 510-788-6041';
    ctx.fillText(text, ImWidth + 10 + canvas.height * 0.05, canvas.height * 0.8 - 3);
    text = 'www.feeneyinc.com';
    ctx.fillText(text, ImWidth + 10 + canvas.height * 0.05, canvas.height - 5);
    fontSize = 38;
    font = 'LatoWebLight';
    // font = "bold " + fontSize + "px " + font;
    ctx.font = 'bold ' + fontSize + 'px ' + font;
    text =
      'Layout above and information contained herin are approved. By signing below you acknowledge that you understand, accept';
    ctx.fillText(text, ImWidth + 20 + canvas.height * 0.05 + tw, canvas.height * 0.3 - 3);
    text =
      'and approve the above quantities, lengths and units as specified. Changes, additions and/or modifications after approval of this';
    ctx.fillText(text, ImWidth + 20 + canvas.height * 0.05 + tw, canvas.height * 0.6 - 3);
    text = 'layout will incur additional charges. Please Proceed. Initial ______ Date ______';
    ctx.fillText(text, ImWidth + 20 + canvas.height * 0.05 + tw, canvas.height * 0.9 - 3);

    ctx.lineWidth = 7;
    // ctx.strokeRect(0, 0, canvas.width, canvas.height);

    if (!this.BottomBlock.material.map) {
      this.BottomBlock.material.map = new THREE.Texture(canvas);
    }
    this.BottomBlock.material.map.image = canvas;

    this.BottomBlock.material.map.needsUpdate = true;
    this.BottomBlock.material.needsUpdate = true;
    this.add(this.BottomBlock);

    ////////////////////////////////////////////////////////////////////////////////////////////
    // ctx.textAlign = 'left';
    // fontSize = 45;
    // let currentPos = ImHeigth + fontSize * 2.6;
    // ctx.font = "bold " + fontSize + "px " + font;
    // this.info.TopItems.forEach(item => {
    //   if (item.value !== "" && item.name !== "DATE") {
    //     text = item.name + ": " + item.value;
    //     ctx.fillText(text, 15, currentPos);
    //     currentPos += fontSize * 1.3;
    //   }
    // });

    // fontSize = 35;

    // ctx.textAlign = 'center';
    // let show = false;
    // text = "Railing";
    // this.info.LeftSideItems.forEach(item => {
    //   if (item.value !== "") {
    //     show = true;
    //   }
    // });
    // if (show) {
    //   ctx.fillText(text, canvas.width / 2, currentPos);
    //   show = false;
    //   currentPos += fontSize * 1.3;
    // }
    // ctx.textAlign = 'left';

    // ctx.font = "bold " + fontSize + "px " + font;
    // this.info.LeftSideItems.forEach(item => {
    //   if (item.value !== "") {
    //     text = item.name + ": " + item.value;
    //     ctx.fillText(text, 15, currentPos);
    //     currentPos += fontSize * 1.3;
    //   }
    // });

    // ctx.textAlign = 'center';
    // text = "Posts";
    // this.info.PostItems.forEach(item => {
    //   if (item.value !== "") {
    //     show = true;
    //   }
    // });
    // if (show) {
    //   ctx.fillText(text, canvas.width / 2, currentPos);
    //   show = false;
    //   currentPos += fontSize * 1.3;
    // }
    // ctx.textAlign = 'left';

    // this.info.PostItems.forEach(item => {
    //   if (item.value !== "") {
    //     text = item.name + ": " + item.value;
    //     ctx.fillText(text, 15, currentPos);
    //     currentPos += fontSize * 1.3;
    //   }
    // });

    // ctx.textAlign = 'center';
    // text = "Top Rail";
    // this.info.TopRailItems.forEach(item => {
    //   if (item.value !== "") {
    //     show = true;
    //   }
    // });
    // if (show) {
    //   ctx.fillText(text, canvas.width / 2, currentPos);
    //   show = false;
    //   currentPos += fontSize * 1.3;
    // }
    // ctx.textAlign = 'left';

    // this.info.TopRailItems.forEach(item => {
    //   if (item.value !== "") {
    //     text = item.name + ": " + item.value;
    //     ctx.fillText(text, 15, currentPos);
    //     currentPos += fontSize * 1.3;
    //   }
    // });

    // ctx.textAlign = 'center';
    // text = "Bottom Rail";
    // this.info.BottomRailItems.forEach(item => {
    //   if (item.value !== "") {
    //     show = true;
    //   }
    // });
    // if (show) {
    //   ctx.fillText(text, canvas.width / 2, currentPos);
    //   show = false;
    //   currentPos += fontSize * 1.3;
    // }
    // ctx.textAlign = 'left';

    // this.info.BottomRailItems.forEach(item => {
    //   if (item.value !== "") {
    //     text = item.name + ": " + item.value;
    //     ctx.fillText(text, 15, currentPos);
    //     currentPos += fontSize * 1.3;
    //   }
    // });

    // ctx.textAlign = 'center';
    // text = "Insert";
    // this.info.InsertItems.forEach(item => {
    //   if (item.value !== "") {
    //     show = true;
    //   }
    // });
    // if (show) {
    //   ctx.fillText(text, canvas.width / 2, currentPos);
    //   show = false;
    //   currentPos += fontSize * 1.3;
    // }
    // ctx.textAlign = 'left';

    // this.info.InsertItems.forEach(item => {
    //   if (item.value !== "") {
    //     text = item.name + ": " + item.value;
    //     ctx.fillText(text, 15, currentPos);
    //     currentPos += fontSize * 1.3;
    //   }
    // });

    // ctx.textAlign = 'center';
    // text = "RS";
    // this.info.RightSideItems.forEach(item => {
    //   if (item.value !== "") {
    //     show = true;
    //   }
    // });
    // if (show) {
    //   ctx.fillText(text, canvas.width / 2, currentPos);
    //   show = false;
    //   currentPos += fontSize * 1.3;
    // }
    // ctx.textAlign = 'left';

    // this.info.RightSideItems.forEach(item => {
    //   if (item.value !== "") {
    //     text = item.name + ": " + item.value;
    //     ctx.fillText(text, 15, currentPos);
    //     currentPos += fontSize * 1.3;
    //   }
    // });

    // ctx.textAlign = 'center';
    // text = "Cables";
    // this.info.CablesItems.forEach(item => {
    //   if (item.value !== "") {
    //     show = true;
    //   }
    // });
    // if (show) {
    //   ctx.fillText(text, canvas.width / 2, currentPos);
    //   show = false;
    //   currentPos += fontSize * 1.3;
    // }
    // ctx.textAlign = 'left';

    // this.info.CablesItems.forEach(item => {
    //   if (item.value !== "") {
    //     text = item.name + ": " + item.value;
    //     ctx.fillText(text, 15, currentPos);
    //     currentPos += fontSize * 1.3;
    //   }
    // });

    // text = "Note: ";
    // if (this.info.Note !== "") {
    //   ctx.fillText(text, 15, currentPos);
    //   currentPos += fontSize * 1.3;
    // }

    // this.printAtWordWrap(ctx, this.info.Note, 15, currentPos, fontSize * 1.3, this.canvasWidth - 15);
  }

  private getDate(): string {
    let today = new Date();
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1; //January is 0!

    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return dd + '/' + mm + '/' + yyyy;
  }

  printAtWordWrap(context, text, x, y, lineHeight, fitWidth) {
    fitWidth = fitWidth || 0;

    if (fitWidth <= 0) {
      context.fillText(text, x, y);
      return;
    }
    var words = text.split(' ');
    var currentLine = 0;
    var idx = 1;
    while (words.length > 0 && idx <= words.length) {
      var str = words.slice(0, idx).join(' ');
      var w = context.measureText(str).width;
      if (w > fitWidth) {
        if (idx == 1) {
          idx = 2;
        }
        context.fillText(words.slice(0, idx - 1).join(' '), x, y + lineHeight * currentLine);
        currentLine++;
        words = words.splice(idx - 1);
        idx = 1;
      } else {
        idx++;
      }
    }
    if (idx > 0) context.fillText(words.join(' '), x, y + lineHeight * currentLine);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/TitleBlock/TitleBlock.ts